"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewPaymentCard extends new_item_1.default {
    constructor(newPaymentCard) {
        super();
        this.cardId = newPaymentCard.cardId;
        this.card = newPaymentCard.card;
        this.bacs_debit = newPaymentCard.bacs_debit;
    }
}
exports.default = NewPaymentCard;
//# sourceMappingURL=new-paymentCard.js.map